"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _get = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var FullJitterBackoff_1 = require("./FullJitterBackoff");
var FullJitterLimitedBackoff = /*#__PURE__*/function (_FullJitterBackoff_1$) {
  _inherits(FullJitterLimitedBackoff, _FullJitterBackoff_1$);
  function FullJitterLimitedBackoff(fixedWaitMs, shortBackoffMs, longBackoffMs, limit) {
    var _this;
    _classCallCheck(this, FullJitterLimitedBackoff);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullJitterLimitedBackoff).call(this, fixedWaitMs, shortBackoffMs, longBackoffMs));
    _this.limit = limit;
    _this.attempts = 0;
    return _this;
  }
  _createClass(FullJitterLimitedBackoff, [{
    key: "nextBackoffAmountMs",
    value: function nextBackoffAmountMs() {
      this.attempts++;
      if (this.attempts > this.limit) {
        throw new Error('retry limit exceeded');
      }
      return _superPropGet(FullJitterLimitedBackoff, "nextBackoffAmountMs", this, 3)([]);
    }
  }]);
  return FullJitterLimitedBackoff;
}(FullJitterBackoff_1.default);
exports.default = FullJitterLimitedBackoff;